<div class="cookies-banner" *ngIf="this.isAbleToShow" #cookieConsentBanner>
  <p class="description-content">
    {{"COOKIE_CONSENT.CONTENT" | translate}}
    <a href="https://innporting.com/legal-notice-conditions/cookies-policy" target="_blank">
      {{"COOKIE_CONSENT.POLICY" | translate}}</a>.
  </p>
  <div class="actions">
    <button mat-raised-button type="submit" class="accept-btn btn btn-fill btn-primary" (click)="acceptCookies()">
      <p class="description-content">{{"COOKIE_CONSENT.BUTTON" | translate}}</p>
    </button>
    <button class="accept-btn btn btn-primary" (click)="rejectCookies()">
      <p class="description-content">{{"COOKIE_CONSENT.REJECT" | translate}}</p>
    </button>
  </div>
</div>
